import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba 3 años dando clases y siempre improvisaba. Con el Método A.C.C.I.Ó.N. armé mis planificaciones de todo el trimestre en un fin de semana. La directora me pidió que se las mostrara a los profes nuevos.',
    author: 'Sebastián R.',
    role: 'Profesor de EF, Buenos Aires'
  }, {
    quote: 'El Tomo 2 me cambió la vida. Tenía un 4° año que era imposible. Empecé a usar las frases del Guión Anti-Caos y en 2 semanas el grupo era otro.',
    author: 'Valeria M.',
    role: 'Profesora de EF, Córdoba'
  }, {
    quote: 'Trabajo en 4 escuelas distintas. Antes llegaba al miércoles destruido. Ahora tengo todo planificado el domingo en 20 minutos.',
    author: 'Rodrigo P.',
    role: 'Profesor de EF, Rosario'
  }];
  return <section className="bg-gray-50 py-20 px-4" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0B1A2E] mb-4" data-id="element-122">
            Lo que dicen los profes que ya lo aplicaron
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-1" data-id="element-123">
          {testimonials.map((test, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-md border border-gray-100 relative" data-id="element-124">
              <div className="flex text-[#F0C14B] mb-4" data-id="element-125">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-126" />)}
              </div>
              <p className="text-lg md:text-xl text-gray-700 italic mb-6 leading-relaxed" data-id="element-127">
                "{test.quote}"
              </p>
              <div data-id="element-128">
                <p className="font-bold text-gray-900 text-lg" data-id="element-129">{test.author}</p>
                <p className="text-gray-500" data-id="element-130">{test.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}